<template>
  <div class="ai-jd-detail">
    <div class="ai-jd-detail-actions">
      <button
        type="button"
        class="btn ai-btn-back"
        :disabled="actionLoading"
        @click="$emit('back')"
      >戻る</button>
      <button
        type="button"
        class="btn ai-btn-select"
        :disabled="actionLoading"
        @click="act('matched')"
      >選択</button>
      <button
        type="button"
        class="btn ai-btn-pass"
        :disabled="actionLoading"
        @click="act('unmatched')"
      >見送り</button>
    </div>

    <div class="ai-jd-detail-scroll">
      <div class="ai-jd-detail-score">
        <div class="ai-jd-detail-score-title">AIマッチングスコア</div>
        <div class="ai-jd-detail-score-item" v-if="jd.llm_score">LLMスコア: {{ jd.llm_score }}点</div>
        <div class="ai-jd-detail-score-item">JDランク: {{ jd.jd_rank }}</div>
      </div>

      <div class="ai-jd-detail-body">
        <div class="ai-jd-detail-title">{{ jd.job_title }}</div>
        <div class="ai-jd-detail-description" v-html="jd.job_description"></div>
        <a
          v-if="jd.jd_url"
          :href="jd.jd_url"
          target="_blank"
          rel="noopener noreferrer"
          class="ai-jd-detail-link"
        >採用ホームページリンク</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AiJdDetail',
  props: {
    jd: {
      type: Object,
      required: true,
    },
    applicantId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      actionLoading: 'getAiJdActionLoading',
    }),
  },
  methods: {
    ...mapActions({
      updateAiMatchStatus: 'updateAiMatchStatus',
    }),
    async act(pairStatus) {
      try {
        await this.updateAiMatchStatus({
          jobseekerId: this.applicantId,
          jd: this.jd,
          pairStatus,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.ai-jd-detail {
  height: 100%;
  position: relative;
  background-color: #fff;
}

.ai-jd-detail-scroll {
  height: 100%;
  overflow-y: auto;
  padding: 20px 24px;
}

.ai-jd-detail-actions {
  position: absolute;
  top: 72px;
  right: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  z-index: 2;
}

.ai-jd-detail-actions .btn {
  width: 80px;
  height: 30px;
  font-size: 12px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.ai-jd-detail-actions .btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.16);
}

.btn.ai-btn-back {
  background-color: #e5e7eb;
  color: #3c3c3c;
  border-color: #e5e7eb;
  font-weight: bold;
}

.btn.ai-btn-select {
  background-color: #2f80ed;
  color: #fff;
  border-color: #2f80ed;
  font-weight: bold;
}

.btn.ai-btn-pass {
  background-color: #eb5757;
  color: #fff;
  border-color: #eb5757;
  font-weight: bold;
}

.ai-jd-detail-score {
  background-color: #f3e8ff;
  border-radius: 10px;
  padding: 10px 18px;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 40px;
  margin-bottom: 20px;
  margin-right: 96px;
}

.ai-jd-detail-score-title {
  font-weight: bold;
  color: #6b21a8;
  font-size: 13px;
}

.ai-jd-detail-score-item {
  font-size: 13px;
  color: #3c3c3c;
}

.ai-jd-detail-title {
  font-size: 19px;
  font-weight: bold;
  color: #222;
  margin-bottom: 14px;
  line-height: 1.4;
}

.ai-jd-detail-description {
  font-size: 14px;
  color: #3c3c3c;
  line-height: 1.7;
  white-space: pre-line;
}

.ai-jd-detail-link {
  display: block;
  margin-top: 15px;
  text-align: right;
  color: #2f80ed;
  font-weight: bold;
  text-decoration: underline;
}
</style>
